if (!customElements.get('metaobject-carousel')) {
  customElements.define('metaobject-carousel', class MetaobjectCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-nav="prev"]');
      this.nextBtn = this.querySelector('[data-nav="next"]');

      if (!this.track) return;

      this.prevBtn?.addEventListener('click', () => this.scroll(-1));
      this.nextBtn?.addEventListener('click', () => this.scroll(1));
    }

    scroll(direction) {
      const slideWidth = this.track.querySelector('.mo-carousel__slide')?.clientWidth || 300;
      this.track.scrollBy({ left: slideWidth * direction, behavior: 'smooth' });
    }
  });
}